import React, { useMemo } from 'react';
import { Container, Sprite } from '@pixi/react';

import { getGameImages } from '../../../core/helpers/getGameImages';

function LobbyIcon({ image, containerConfig, lobbyIconPostMessage, lobbyIconContainerRef }) {
  const { lobbyIconBoard } = useMemo(() => {
    return getGameImages();
  }, []);

  return (
    <Container
      name='LobbyIcon'
      cursor='pointer'
      {...containerConfig}
      ref={lobbyIconContainerRef}
      pointerdown={(e) => {
        lobbyIconPostMessage(e);
      }}
    >
      <Sprite texture={lobbyIconBoard} anchor={{ x: 1, y: 0.5 }} />
      <Sprite image={image} anchor={{ x: 1, y: 0.5 }} scale={0.5} x={-5} />
    </Container>
  );
}

export default LobbyIcon;
